<!-- Barra de menu-->
<navbar-component></navbar-component>

<main class="background">

  <div class="head">
    <img src="./../../assets/icons/contact.svg" alt="Ícone Comunicação" id="head-icon">
    <div class="container-title">
        <div class="title">
            Comunicação
        </div>
    </div>
  </div>

  <!-- <div class="container"> -->
    <form class="form" #form="ngForm" (ngSubmit)="send(form)">
      <div class="contact-container-card--form-input">
        <label for="name">Nome*</label>
        <input [(ngModel)]="contactForm.name" #name="ngModel" type="text" id="name" name="name" class="form-control" placeholder="Digite o seu nome" required>

        <div class="contact-container-card--form-input-error" *ngIf="name.invalid && (name.dirty || name.touched)">
          <mat-error *ngIf="name.errors?.['required']">Este campo é obrigatório</mat-error>
        </div>
      </div>

      <div class="contact-container-card--form-input">
        <label for="email">Email*</label>
        <input [(ngModel)]="contactForm.email" #email="ngModel" type="email" email id="email" name="email" class="form-control" placeholder="Digite o seu e-mail" required>

        <div class="contact-container-card--form-input-error" *ngIf="email.invalid && (email.dirty || email.touched)">
          <mat-error *ngIf="email.invalid && !email.errors?.['required']">Digite o e-mail no formato correto</mat-error>
          <mat-error *ngIf="email.errors?.['required']">Este campo é obrigatório</mat-error>
        </div>
      </div>

      <div class="contact-container-card--form-input">
        <label for="phone">Telefone*</label>
        <input [(ngModel)]="contactForm.phone" mask="(00) 00000-0000" minlength="11" #phone="ngModel" type="tel" phone id="phone" name="phone" class="form-control" placeholder="Digite o seu telefone" required>

        <div class="contact-container-card--form-input-error" *ngIf="phone.invalid && (phone.dirty || phone.touched)">
          <mat-error *ngIf="phone.errors?.['minlength'] && !phone.errors?.['required']">Este campo deve ter 11 digitos</mat-error>
          <mat-error *ngIf="phone.errors?.['required']">Este campo é obrigatório</mat-error>
        </div>
      </div>

      <div class="contact-container-card--form-input">
        <label for="email">Mensagem*</label>
        <textarea [(ngModel)]="contactForm.message" #message="ngModel" style="min-height: 20vh;" type="text" id="message" name="message" class="form-control" placeholder="Digite sua mensagem" required></textarea>

        <div class="contact-container-card--form-input-error" *ngIf="message.invalid && (message.dirty || message.touched)">
          <mat-error *ngIf="message.errors?.['required']">Este campo é obrigatório</mat-error>
        </div>
      </div>

      <button class="btn btn-primary contact-container-card--form-submit" type="submit" [disabled]="form.invalid">Enviar</button>
    </form>
  <!-- </div> -->

</main>

<!-- Footer and copyright -->
<footer-component></footer-component>
